import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit, OnDestroy {
  constructor(
    private loaderService: LoaderService,
    public spinner: NgxSpinnerService
  ) {
    $("#overDiv").hide();
    this.loaderService.isLoading$.subscribe((v) => {
      // console.log("Loading--->" + v);
      if (v) {
        $("#overDiv").show();
        this.spinner.show();
      } else {
        //  setTimeout(() => {
        $("#overDiv").hide();
        this.spinner.hide();
        // }, 1000);
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    if (this.loaderService.isLoading$) {
      this.loaderService.isLoading$.unsubscribe();
    }
  }
}
